import { useEffect, useState } from "react";
import { getExchangeViewer } from "../store/exchanges";

/** Mounted only after Firebase authentication, in the stable link's own tab. */
export default function ExchangeViewer({ companyId, id }: { companyId: string; id: string }) {
  const [attempt, setAttempt] = useState(0), [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    if (!companyId || !id) { setError("This conversation link is incomplete. Open it again from the dashboard."); return; }
    setError("");
    void getExchangeViewer(id, companyId).then(url => { if (current) window.location.replace(url); })
      .catch(cause => { if (current) setError(cause instanceof Error ? cause.message : "Could not open the conversation."); });
    return () => { current = false; };
  }, [companyId, id, attempt]);
  return <main className="exchangeViewer"><section className="reviewCard"><h1>{error ? "Conversation Unavailable" : "Opening Conversation…"}</h1>
    <p className="reviewNotice" role={error ? "alert" : "status"}>{error || "Checking your owner access and preparing a fresh viewer link."}</p>
    <div className="reviewCard__actions">{error && <button type="button" className="schedBtn" onClick={() => setAttempt(value => value + 1)}>Retry</button>}
      <a className="reviewCard__link" href={companyId ? `/?chat=${encodeURIComponent(companyId)}` : "/"}>Back to Dashboard</a></div>
  </section></main>;
}
